import { create, useStore } from "zustand";

interface FinancialStore {
    fee: number;
    followingsFee: number
    tokenCreatorFee: number;
    lowFeeUsd: number;
    transactionUsdBound: number;
    crowdfundingUsdBound: number;
}

export const financialStore = create<FinancialStore>((_set) => ({
    fee: 0,
    followingsFee: 0,
    tokenCreatorFee: 0,
    transactionUsdBound: 0,
    lowFeeUsd: 0,
    crowdfundingUsdBound: 0,
}));

export const useFinancialStore = () => useStore(financialStore);
